/*
 * Chevaux Nature — Kaufleiste auf der Produktseite (Handy), Stand 04.10.2026.
 *
 * Eingebunden von sections/product.liquid. Der Block „Kaufleiste (Handy)“
 * gibt nur eine Markierung aus (<div data-cn-kaufleiste-an hidden>). Dieses
 * Skript baut daraufhin EINMAL eine Leiste als Kind von document.body:
 *
 *   - nicht im Produktbereich, weil Shopify den bei jedem Variantenwechsel
 *     neu baut (Morphing) und die Leiste dabei ersetzt würde;
 *   - nicht unter einem Vorfahren mit transform, weil position: fixed dort
 *     nicht mehr am Bildschirm klebt, sondern am Vorfahren.
 *
 * Was die Leiste zeigt, ist nichts Eigenes, sondern gelesen:
 *   - links die gewählten Optionswerte aus der Seite, mit „ · “ verbunden
 *     (ohne Optionen der Produkttitel),
 *   - rechts eine Live-Kopie der Beschriftung des echten Kaufknopfs, samt
 *     „• 490 €“. Es entsteht also kein neuer Satz und keine neue Übersetzung.
 *
 * Ein Tipp auf den Leistenknopf ruft den echten Kaufknopf auf (.click()).
 * Damit läuft exakt derselbe Weg wie bei einem Tipp auf den echten Knopf:
 * Maßfeld-Sperre, Schublade, Ereignisse. Dieses Skript schickt nie selbst ein
 * Formular ab, ruft nie /cart/add auf und fasst die Kasse nicht an.
 *
 * Sichtbar ist die Leiste genau dann, wenn der echte Knopf nach OBEN aus dem
 * Bild ist (getBoundingClientRect().bottom < 0) und der Bildschirm schmaler
 * als 768 px ist. Der Zustand steht als Klasse am body und übersteht so das
 * Morphing. Aussehen und Platz für den Chat-Kreis: assets/chvx-produktseite.css.
 *
 * Zweite, davon unabhängige Aufgabe (04.10.2026, Marc 03.10.: „WhatsApp-Blase
 * korrigieren“): Läuft beim Scrollen der echte Kaufknopf oder der Express-Knopf
 * durch die untere rechte Ecke, deckt der WhatsApp-Kreis (#chat-bubble) das
 * rechte Ende des Knopfs samt Preis zu (gemessen in der Kopie: 41 × 47 px, auf
 * allen acht gemessenen Produktseiten). Dann steht die Klasse
 * cn-knopf-unter-chat am body, und die CSS blendet den Kreis aus. Siehe
 * chatAbgleich() unten. Sie läuft auch ohne Marker und ohne Leiste.
 *
 * Rückweg Leiste: Block „Kaufleiste (Handy)“ im Theme-Editor ausblenden. Ohne
 * Markierung baut das Skript keine Leiste und nimmt eine vorhandene weg.
 * Rückweg Kreis: in chvx-produktseite.css die Regel für
 * body.cn-knopf-unter-chat löschen; die Klasse bleibt dann ohne Wirkung.
 */
(function () {
  'use strict';

  /* Mehrfach geladen (Theme-Editor setzt den Abschnitt neu): nur einmal starten.
     Alle Verweise unten werden bei jedem Durchlauf neu gesucht, die erste
     Fassung kommt also auch nach dem Neubau der Seite zurecht. */
  if (window.__chvxProduktseite) return;
  window.__chvxProduktseite = true;

  var MARKE = '[data-cn-kaufleiste-an]';
  var KNOPF = 'form[data-product-form] button[data-add-to-cart]';
  var KLASSE = 'cn-kaufleiste-sichtbar';
var KLASSE_DA = 'cn-kaufleiste-da';
  var KLASSE_CHAT = 'cn-knopf-unter-chat';
  var CHAT_KREIS = '#chat-bubble';            // der WhatsApp-Kreis, 47 × 47 px, fest unten rechts
  var EXPRESS = '.shopify-payment-button';    // Express-Knopf (PayPal u. a.) im Produktbereich
  var CHAT_RAND = 6;                          // px Sicherheitsrand um den Kreis

  var schmal = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
  var reduziert = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  var leiste = null;      // das Element unter dem body
  var variantenZeile = null;
  var leistenKnopf = null;
  var textBeschriftung = null;
  var textPunkt = null;
  var textPreis = null;

  var letzteVariante = null;
  var letzterText = null;
  var letzteSperre = null;
  var zuletztSichtbar = false;
var ohneStil = false;   // die Stilregeln sind nicht angekommen: dann nie eine Leiste bauen
  var chatVerdeckt = false;   // Klasse cn-knopf-unter-chat gerade am body?

  function istSchmal() {
    return schmal ? schmal.matches : window.innerWidth < 768;
  }

  function markeDa() {
    return !!document.querySelector(MARKE);
  }

  /* Der echte Kaufknopf des Produktbereichs. Der Knopf wird beim
     Variantenwechsel neu gerendert, deshalb wird er bei jedem Gebrauch neu
     gesucht und nie gemerkt. Karten im Raster („Das könnte dir auch gefallen“)
     haben kein form[data-product-form]; der Produktabschnitt wird trotzdem
     bevorzugt. */
  function findeKnopf() {
    var alle = document.querySelectorAll(KNOPF);
    for (var i = 0; i < alle.length; i++) {
      if (alle[i].closest('[data-section-type="product"]')) return alle[i];
    }
    return alle.length ? alle[0] : null;
  }

  function normal(text) {
    return String(text == null ? '' : text).replace(/\s+/g, ' ').trim();
  }

  /* Beschriftung des echten Knopfs in ihren Teilen: Text, Punkt, Preis. Die
     Teile werden getrennt gespiegelt, damit bei langem Text (andere Sprachen)
     der Text mit Auslassungspunkten gekürzt wird und nie der Preis. Die
     Zustandsspans für „lädt“ und „fertig“ tragen keinen Text. Fehlt die
     Struktur, zählt der ganze Knopf als ein Text. */
  function teileVon(knopf) {
    var bereit = knopf.querySelector('.btn-state-ready') || knopf;
    var beschriftung = knopf.querySelector('[data-add-to-cart-text]');
    var preis = knopf.querySelector('[data-button-price]');
    var punkt = knopf.querySelector('.cta__dot');
    var t;
    if (beschriftung && preis) {
      t = {
        beschriftung: normal(beschriftung.textContent),
        punkt: punkt ? normal(punkt.textContent) : '',
        preis: normal(preis.textContent)
      };
    } else {
      t = { beschriftung: normal(bereit.textContent), punkt: '', preis: '' };
    }
    t.ganz = [t.beschriftung, t.punkt, t.preis].filter(Boolean).join(' ');
    return t;
  }

  function istGesperrt(knopf) {
    return !!knopf && (knopf.disabled || knopf.getAttribute('aria-disabled') === 'true');
  }

  /* Gewählte Optionswerte, in der Reihenfolge der Seite. Es gibt drei
     Bauarten (snippets/product-variant-options.liquid): Radiofelder
     (Kästchen und Farbkreise), ein Aufklapp-Feld mit verstecktem Eingabefeld,
     und den angezeigten Wert in der Überschrift. Der Wert des Radiofelds
     wird dem Beschriftungstext vorgezogen: der enthält bei ausverkauften
     Varianten noch einen versteckten Zusatz. */
  function variantenText(knopf) {
    var bereich = (knopf && knopf.closest('[data-section-type="product"]')) || document;
    var felder = bereich.querySelectorAll('.selector-wrapper');
    var werte = [];

    for (var i = 0; i < felder.length; i++) {
      var feld = felder[i];
      var wert = '';

      var gewaehlt = feld.querySelector('input[type="radio"]:checked');
      if (gewaehlt) {
        wert = normal(gewaehlt.value);
      }
      if (!wert) {
        var versteckt = feld.querySelector('input[data-popout-input]');
        if (versteckt) wert = normal(versteckt.value);
      }
      if (!wert) {
        var knopfFeld = feld.querySelector('.select-popout__toggle');
        if (knopfFeld) wert = normal(knopfFeld.textContent);
      }
      if (!wert) {
        var anzeige = feld.querySelector('[data-option-value]');
        if (anzeige) wert = normal(anzeige.textContent);
      }
      if (wert) werte.push(wert);
    }

    if (werte.length) return werte.join(' · ');

    var titel = document.querySelector('h1.product__title') || document.querySelector('.product__title');
    return titel ? normal(titel.textContent) : '';
  }

  /* ---- Leiste bauen und abbauen ------------------------------------------ */

  function baueLeiste() {
    if (leiste && leiste.isConnected) return;

    leiste = document.createElement('div');
    leiste.className = 'cn-kaufleiste';
    leiste.setAttribute('data-cn-kaufleiste', '');
    leiste.setAttribute('aria-hidden', 'true');
    leiste.setAttribute('inert', '');

    variantenZeile = document.createElement('div');
    variantenZeile.className = 'cn-kaufleiste__variante';

    leistenKnopf = document.createElement('button');
    leistenKnopf.type = 'button';
    leistenKnopf.className = 'btn btn--neutral cn-kaufleiste__knopf';

    var knopfText = document.createElement('span');
    knopfText.className = 'cn-kaufleiste__knopf-text';
    textBeschriftung = document.createElement('span');
    textBeschriftung.className = 'cn-kaufleiste__beschriftung';
    textPunkt = document.createElement('span');
    textPunkt.className = 'cn-kaufleiste__punkt';
    textPreis = document.createElement('span');
    textPreis.className = 'cn-kaufleiste__preis';
    /* Leerzeichen als Textknoten: im Flex-Behälter zeichnen sie nichts,
       aber Vorleseprogramme und textContent lesen „In den Warenkorb • 490 €“. */
    knopfText.appendChild(textBeschriftung);
    knopfText.appendChild(document.createTextNode(' '));
    knopfText.appendChild(textPunkt);
    knopfText.appendChild(document.createTextNode(' '));
    knopfText.appendChild(textPreis);
    leistenKnopf.appendChild(knopfText);

    leiste.appendChild(variantenZeile);
    leiste.appendChild(leistenKnopf);
    document.body.appendChild(leiste);

    /* Ohne chvx-produktseite.css wäre das ein ungestaltetes Stück Text am Ende
       der Seite. Dann lieber keine Leiste: position: fixed steht nur in der
       CSS-Datei, daran erkennt man, ob sie da ist. */
    if (window.getComputedStyle(leiste).position !== 'fixed') {
      ohneStil = true;
      entferneLeiste();
      return;
    }

    document.body.classList.add(KLASSE_DA);
    leistenKnopf.addEventListener('click', beiTipp);

    letzteVariante = letzterText = letzteSperre = null;
  }

  function entferneLeiste() {
    if (leiste && leiste.parentNode) leiste.parentNode.removeChild(leiste);
    leiste = variantenZeile = leistenKnopf = textBeschriftung = textPunkt = textPreis = null;
    zuletztSichtbar = false;
    document.body.classList.remove(KLASSE);
    document.body.classList.remove(KLASSE_DA);
  }

  /* ---- Inhalt der Leiste aus dem echten Knopf spiegeln ------------------- */

  function spiegeln() {
    if (!leiste) return;
    var knopf = findeKnopf();
    if (!knopf) return;   // mitten im Neubau: alten Stand stehen lassen

    var teile = teileVon(knopf);
    if (teile.ganz !== letzterText) {
      textBeschriftung.textContent = teile.beschriftung;
      textPunkt.textContent = teile.punkt;
      textPunkt.hidden = !teile.punkt;
      textPreis.textContent = teile.preis;
      textPreis.hidden = !teile.preis;
      leistenKnopf.setAttribute('aria-label', teile.ganz);
      letzterText = teile.ganz;
    }

    var variante = variantenText(knopf);
    if (variante !== letzteVariante) {
      variantenZeile.textContent = variante;
      variantenZeile.title = variante;
      letzteVariante = variante;
    }

    var gesperrt = istGesperrt(knopf);
    if (gesperrt !== letzteSperre) {
      leistenKnopf.setAttribute('aria-disabled', gesperrt ? 'true' : 'false');
      leistenKnopf.classList.toggle('cn-kaufleiste__knopf--aus', gesperrt);
      letzteSperre = gesperrt;
    }
  }

  /* ---- Sichtbarkeit ------------------------------------------------------ */

  function zeigen(an) {
    if (an === zuletztSichtbar) return;
    zuletztSichtbar = an;
    document.body.classList.toggle(KLASSE, an);
    if (leiste) {
      leiste.setAttribute('aria-hidden', an ? 'false' : 'true');
      if (an) leiste.removeAttribute('inert');
      else leiste.setAttribute('inert', '');
    }
  }

  /* Rechteck b näher als CHAT_RAND px am Kreis a (oder darunter)? Ein Rechteck
     ohne Fläche (display: none, noch nicht gemessen) zählt nie. */
  function beruehrt(a, b) {
    if (!(b.width > 0 && b.height > 0)) return false;
    return a.left - CHAT_RAND < b.right && a.right + CHAT_RAND > b.left &&
           a.top - CHAT_RAND < b.bottom && a.bottom + CHAT_RAND > b.top;
  }

  /* Sitzt der WhatsApp-Kreis auf dem echten Kaufknopf oder dem Express-Knopf
     (mit CHAT_RAND px Rand)? Dann bekommt der body die Klasse KLASSE_CHAT, sonst
     nicht; die CSS blendet den Kreis in dieser Zeit aus. Der Kreis wird nicht
     verschoben und nicht berührt: andere Regeln setzen sein bottom, und ein
     Ausblenden (opacity) ändert sein Rechteck nicht — die Messung hier kann also
     nicht auf sich selbst antworten.
     Der Express-Knopf wird im Produktbereich des echten Knopfs gesucht, nicht auf
     der ganzen Seite (Karten im Raster haben auch einen). Nur unter 768 px.
     Geschrieben wird nur, wenn sich der Zustand ändert. */
  function chatAbgleich() {
    var an = false;
    if (istSchmal()) {
      var knopf = findeKnopf();
      if (!knopf) return;   // mitten im Neubau: Zustand halten
      var kreis = document.querySelector(CHAT_KREIS);
      var k = kreis ? kreis.getBoundingClientRect() : null;
      /* Kein Kreis oder ohne Fläche: nichts zu verdecken. */
      if (k && k.width > 0 && k.height > 0) {
        an = beruehrt(k, knopf.getBoundingClientRect());
        if (!an) {
          var bereich = knopf.closest('[data-section-type="product"]') || document;
          var express = bereich.querySelectorAll(EXPRESS);
          for (var i = 0; i < express.length && !an; i++) {
            an = beruehrt(k, express[i].getBoundingClientRect());
          }
        }
      }
    }
    if (an === chatVerdeckt) return;
    chatVerdeckt = an;
    document.body.classList.toggle(KLASSE_CHAT, an);
  }

  /* chatSchonGeprueft: abgleich() hat chatAbgleich() eben selbst aufgerufen. */
  function sichtbarkeit(chatSchonGeprueft) {
    if (!chatSchonGeprueft) chatAbgleich();
    if (!leiste || !istSchmal()) {
      zeigen(false);
      return;
    }
    var knopf = findeKnopf();
    if (!knopf) return;   // mitten im Neubau: Zustand halten, nichts flackern lassen
    zeigen(knopf.getBoundingClientRect().bottom < 0);
  }

  /* ---- Gesamtabgleich ---------------------------------------------------- */

  function abgleich() {
    /* Als Erstes und vor jedem frühen Ende: der Kreis hängt nicht an der Leiste
       und muss auch am Desktop (Klasse wieder weg) und ohne Marker laufen. */
    chatAbgleich();
    if (!markeDa() || !istSchmal()) {
      /* Marke weg (Editor, Block ausgeblendet) oder Desktop: keine Leiste. */
      if (!markeDa()) entferneLeiste();
      else zeigen(false);
      return;
    }
    if (ohneStil) return;
    baueLeiste();
    if (!leiste) return;
    spiegeln();
    sichtbarkeit(true);
  }

  var rafAbgleich = 0;
  var rafSicht = 0;

  function planeAbgleich() {
    if (rafAbgleich) return;
    rafAbgleich = window.requestAnimationFrame(function () {
      rafAbgleich = 0;
      abgleich();
    });
  }

  function planeSichtbarkeit() {
    if (rafSicht || rafAbgleich) return;
    rafSicht = window.requestAnimationFrame(function () {
      rafSicht = 0;
      sichtbarkeit();
    });
  }

  /* ---- Tipp auf den Leistenknopf ----------------------------------------- */

  function beiTipp() {
    var knopf = findeKnopf();   // frisch suchen: der alte kann ersetzt worden sein
    if (!knopf) return;

    if (istGesperrt(knopf)) {
      /* Nicht kaufbar: nichts auslösen, den echten Knopf in die Mitte holen. */
      var ruhig = reduziert && reduziert.matches;
      knopf.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'center' });
      return;
    }

    /* Zweiter Tipp, solange der erste noch läuft: der echte Knopf trägt dann
       die Klasse „loading“. Nicht noch einmal auslösen. */
    if (knopf.classList.contains('loading')) return;

    knopf.click();
  }

  /* ---- Beobachter -------------------------------------------------------- */

  /* Der Produktbereich wird neu gebaut, Texte und Knöpfe werden ersetzt. Ein
     Beobachter am body fängt beides: neue Knoten (Knopf ersetzt, Block im
     Editor hinzugefügt oder entfernt), geänderte Texte (Preis, Beschriftung)
     und das Attribut disabled. Änderungen an der Leiste selbst werden
     übergangen, sonst riefe jede Spiegelung die nächste auf. */
  function beobachten() {
    if (!window.MutationObserver) return;
    var beobachter = new MutationObserver(function (liste) {
      for (var i = 0; i < liste.length; i++) {
        if (leiste && leiste.contains(liste[i].target)) continue;
        planeAbgleich();
        return;
      }
    });
    beobachter.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'checked']
    });
  }

  function starten() {
    beobachten();
    window.addEventListener('scroll', planeSichtbarkeit, { passive: true });
    window.addEventListener('resize', planeAbgleich);
    window.addEventListener('orientationchange', planeAbgleich);
    window.addEventListener('pageshow', planeAbgleich);
    window.addEventListener('load', planeAbgleich);
    document.addEventListener('shopify:section:load', planeAbgleich);
    document.addEventListener('shopify:section:unload', planeAbgleich);
    document.addEventListener('shopify:block:select', planeAbgleich);
    document.addEventListener('shopify:block:deselect', planeAbgleich);
    /* Ein gewähltes Radiofeld ändert nur die Eigenschaft checked, kein
       Attribut: das Ereignis fängt, was der Beobachter nicht sieht. */
    document.addEventListener('change', planeAbgleich, true);
    abgleich();
  }

  if (!document.body) {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }
})();
